import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    background: '#FAFAFA',
    // outras propriedades que quiser para as linhas
  },
  avatar: {
    width: 45,
    height: 45,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '16px 0',
  },
  table: {
    minWidth: 650,
    background: '#ffffff',
  },
}));
